import React from 'react';

const PrivacyPolicyContent = () => {
  return (
    <div className="prose dark:prose-invert max-w-none">
      <h2 className="text-2xl font-bold mb-4">Privacy Policy</h2>
      <p className="mb-2">
        <strong>Last updated: October 29, 2025</strong>
      </p>
      <p className="mb-4">
        Padam Technologies QFZ LLC ("us", "we", or "our") operates the SceneShop Showcase Portal (the "Service").
        This page informs you of our policies regarding the collection, use, and disclosure of personal data
        when you use our Service and the choices you have associated with that data.
      </p>
      <h3 className="text-xl font-semibold mb-3">Information Collection And Use</h3>
      <p className="mb-4">
        We collect several different types of information for various purposes to provide and improve our Service to you.
      </p>
      <h4 className="text-lg font-semibold mb-2">Types of Data Collected</h4>
      <p className="mb-1">
        <strong>Personal Data</strong>
      </p>
      <p className="mb-4">
        While using our Service, we may ask you to provide us with certain personally identifiable information
        that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:
      </p>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>Email address</li>
        <li>First name and last name</li>
        <li>Phone number</li>
        <li>Address, State, Province, ZIP/Postal code, City</li>
        <li>Usage Data</li>
      </ul>
      <p className="mb-1">
        <strong>Usage Data</strong>
      </p>
      <p className="mb-4">
        We may also collect information how the Service is accessed and used ("Usage Data"). This Usage Data may include
        information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version,
        the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers
        and other diagnostic data.
      </p>
      <h3 className="text-xl font-semibold mb-3">Use of Data</h3>
      <p className="mb-4">
        Padam Technologies QFZ LLC uses the collected data for various purposes:
      </p>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>To provide and maintain the Service</li>
        <li>To notify you about changes to our Service</li>
        <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
        <li>To provide customer care and support</li>
        <li>To provide analysis or valuable information so that we can improve the Service</li>
        <li>To monitor the usage of the Service</li>
        <li>To detect, prevent and address technical issues</li>
      </ul>
      <h3 className="text-xl font-semibold mb-3">Disclosure Of Data</h3>
      <p className="mb-4">
        We may disclose your Personal Data in the good faith belief that such action is necessary to:
      </p>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>To comply with a legal obligation</li>
        <li>To protect and defend the rights or property of Padam Technologies QFZ LLC</li>
        <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
        <li>To protect the personal safety of users of the Service or the public</li>
        <li>To protect against legal liability</li>
      </ul>
      <h3 className="text-xl font-semibold mb-3">Security Of Data</h3>
      <p className="mb-4">
        The security of your data is important to us, but remember that no method of transmission over the Internet,
        or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data,
        we cannot guarantee its absolute security.
      </p>
      <h3 className="text-xl font-semibold mb-3">Links To Other Sites</h3>
      <p className="mb-4">
        Our Service may contain links to other sites that are not operated by us. If you click on a third-party link,
        you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
      </p>
      <p className="mb-4">
        We have no control over and assume no responsibility for the content, privacy policies or practices of any third-party sites or services.
      </p>
      <h3 className="text-xl font-semibold mb-3">Changes To This Privacy Policy</h3>
      <p className="mb-4">
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
      </p>
      <p className="mb-4">
        We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective
        and update the "last updated" date at the top of this Privacy Policy.
      </p>
      <p className="mb-4">
        You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
      </p>
      <h3 className="text-xl font-semibold mb-3">Contact Us</h3>
      <p className="mb-2">
        If you have any questions about this Privacy Policy, please contact us:
      </p>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>By email: contact@padam.ai</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicyContent;
